import { createSlice } from '@reduxjs/toolkit';
import { getBranchTransfers, getInvestment, getSuspenseTransactions } from './investmentMiddleware';
import { type InvestmentResponse, type Investment, type BranchTransfer, type BranchTransferResponse } from './investmentTypes';

interface InitialState {
  investment: Investment;
  investments: InvestmentResponse[];
  branchTransfer: BranchTransfer;
  branchTransfers: BranchTransferResponse[];
  suspenseTransactions?: InvestmentResponse[];
}

const initialState: InitialState = {
  investment: {
    branch: '',
    amount: 0,
    investedBy: '',
    transactionDate: ''
  },
  branchTransfer: {
    fromBranch: '',
    toBranch: '',
    amount: 0,
    description: '',
    transactionDate: ''
  },
  investments: [],
  branchTransfers: [],
  suspenseTransactions: []
};

const investmentReducer = createSlice({
  name: 'investmentReducer',
  reducers: {
    resetDeposits(state) {
      state.investments = initialState.investments
    },
    resetBranchTransfers(state) {
      state.branchTransfers = initialState.branchTransfers
    }
  },
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getInvestment.fulfilled, (state, action) => {
      state.investments = action.payload;
    });
    builder.addCase(getBranchTransfers.fulfilled, (state, action) => {
      state.branchTransfers = action.payload;
    });
    builder.addCase(getSuspenseTransactions.fulfilled, (state, action) => {
      state.suspenseTransactions = action.payload;
    });
  },
});

export const { resetDeposits, resetBranchTransfers } = investmentReducer.actions;
export default investmentReducer.reducer;